/*
 * @Author: v-fmasoud@tableau.com
 * @Date: 2017-10-10 11:22:03
 * @Last Modified by: v-fmasoud@tableau.com
 * @Last Modified time: 2018-02-27 14:36:31
 */
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {
  CHANGEMYEMAIL_ROUTE,
  CHANGEPASSWORD_ROUTE,
  HOME_ROUTE,
  MANAGEACCOUNT_ROUTE,
  REGISTER_ROUTE,
  RESETPASSWORD_ROUTE,
  SIGN_ME_OUT_ROUTE,
  SIGNOUT_ROUTE,
} from '../../routes';
import { getProfile } from '../../common/SessionManager';
import tableauLogo from '../../assets/images/logo.png';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.menuRef = React.createRef();
    this.buttonRef = React.createRef();
  }

   getMenuItems = () => {
    if (!this.menuRef.current) return [];
    return Array.from(
      this.menuRef.current.querySelectorAll('[role="menuitem"]')
    );
  };

  componentDidUpdate(prevProps, prevState) {
    // When menu opens, move focus to first menu item
    if (!prevState.isOpen && this.state.isOpen) {
      setTimeout(() => {
        const menuItems = this.getMenuItems();
        if (menuItems.length > 0) {
          menuItems[0].focus();
        }
      }, 100);
    }
  }

  handleMenuKeyDown = (e) => {
    if (!this.state.isOpen) return;

    const menuItems = this.getMenuItems();
    if (menuItems.length === 0) return;

    const currentIndex = menuItems.findIndex(
      (item) => item === document.activeElement
    );

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        const nextIndex =
          currentIndex < menuItems.length - 1 ? currentIndex + 1 : 0;
        menuItems[nextIndex].focus();
        break;
      case "ArrowUp":
        e.preventDefault();
        const prevIndex =
          currentIndex > 0 ? currentIndex - 1 : menuItems.length - 1;
        menuItems[prevIndex].focus();
        break;
      case "Escape":
        e.preventDefault();
        this.setState({ isOpen: false });
        if (this.buttonRef.current) {
          this.buttonRef.current.focus();
        }
        break;
      case "Tab":
        // Close menu on Tab, let default behavior continue
        this.setState({ isOpen: false });
        break;
      default:
        break;
    }
  };

  handleButtonKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.setState((prevState) => ({
        isOpen: !prevState.isOpen,
      }));
    }
  };


  render() {
    const { t, hideAuthLinks } = this.props;
    const profile = getProfile();

    const isRegisterPage = window.location.pathname.toUpperCase() === REGISTER_ROUTE.toUpperCase();
    const isResetPage = window.location.pathname.toUpperCase() === RESETPASSWORD_ROUTE.toUpperCase();
    // Preserve the current query string (e.g. ?clientId=...) across public
    // auth nav so freemium bare-layout detection keeps working after clicks.
    const currentSearch = window.location.search;

    const toggleHamburger = () => {
      this.setState(prevState => ({
        ...prevState,
        isOpen: !prevState.isOpen,
      }));
    };
    const hide = () => {
      this.setState(prevState => ({
        ...prevState,
        isOpen: false,
      }));
    };

    const signOutUrl = `${SIGN_ME_OUT_ROUTE}?goto=${window.REACT_APP_BASE_URL}${SIGNOUT_ROUTE}`;
    return (
      <header className="global-nav">
        <div className="global-nav__top content-container content-container--wide">
          <div className="relative clearfix">
            <div id="global-nav-logo" className="global-nav__logo">
              <a href="//www.tableau.com/">
                <img
                  src={tableauLogo}
                  alt="Tableau Software"
                />
              </a>
            </div>
            <div
              className={`global-nav__hamburger ${
                this.state.isOpen ? "open" : ""
              }`}
            >
              <div
                id="hamburgerMenu"
                ref={this.buttonRef}
                role="button"
                aria-label={this.state.isOpen ? "Close menu" : "Menu"}
                aria-haspopup="menu"
                aria-controls="navigation-menu"
                aria-expanded={this.state.isOpen}
                className={`hamburger ${
                  this.state.isOpen ? "hamburger--open" : ""
                }`}
                onClick={toggleHamburger}
                onKeyDown={this.handleButtonKeyDown}
                tabIndex={0}
              >
                <span className="hamburger__patty">Menu</span>
              </div>
            </div>
            <div
              id="navigation-menu"
              className={`global-nav__mobile-wrapper is-mobile ${
                this.state.isOpen ? "is-open" : ""
              }`}
              {...(!this.state.isOpen && { "aria-hidden": true })}
              ref={this.menuRef}
              onKeyDown={this.handleMenuKeyDown}
            >
              <nav
                className="global-nav__primary-menu"
                role="menu"
                aria-label="Main navigation"
              >
                <ul role="none">
                  <li role="none">
                    {profile ? (
                      <Link
                        to={signOutUrl}
                        id="signOutLink"
                        onClick={hide}
                        role="menuitem"
                        tabIndex={this.state.isOpen ? 0 : -1}
                      >
                        {t("Sign_Out")}
                      </Link>
                    ) : (
                      !hideAuthLinks && (
                        <Link
                          to={{ pathname: HOME_ROUTE, search: currentSearch }}
                          id="signInLink"
                          onClick={hide}
                          role="menuitem"
                          tabIndex={this.state.isOpen ? 0 : -1}
                        >
                          {t("Sign_In")}
                        </Link>
                      )
                    )}
                  </li>
                  {!profile && !isRegisterPage && !hideAuthLinks && (
                    <li role="none">
                      <Link
                        to={{ pathname: REGISTER_ROUTE, search: currentSearch }}
                        id="registerLink"
                        onClick={hide}
                        role="menuitem"
                        tabIndex={this.state.isOpen ? 0 : -1}
                      >
                        {t("Register")}
                      </Link>
                    </li>
                  )}
                  {profile && (
                    <li role="none">
                      <Link
                        to={CHANGEPASSWORD_ROUTE}
                        id="changePasswordLink"
                        onClick={hide}
                        role="menuitem"
                        tabIndex={this.state.isOpen ? 0 : -1}
                      >
                        {t("Change_Password")}
                      </Link>
                    </li>
                  )}
                  {!profile && !isResetPage && !hideAuthLinks && (
                    <li role="none">
                      <Link
                        to={{ pathname: RESETPASSWORD_ROUTE, search: currentSearch }}
                        id="resetPasswordLink"
                        onClick={hide}
                        role="menuitem"
                        tabIndex={this.state.isOpen ? 0 : -1}
                      >
                        {t("Reset_Password")}
                      </Link>
                    </li>
                  )}
                  {profile && !profile.profileAdmin && !profile.profileReader && (
                    <li role="none">
                      <Link
                        to={CHANGEMYEMAIL_ROUTE}
                        id="changeEmailLink"
                        onClick={hide}
                        role="menuitem"
                        tabIndex={this.state.isOpen ? 0 : -1}
                      >
                        {t("Change_Email")}
                      </Link>
                    </li>
                  )}
                  {profile && (
                    <li role="none">
                      <Link
                        to={MANAGEACCOUNT_ROUTE}
                        id="manageAccountLink"
                        onClick={hide}
                        role="menuitem"
                        tabIndex={this.state.isOpen ? 0 : -1}
                      >
                        {t("Manage_Account")}
                      </Link>
                    </li>
                  )}
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <hr className="divider divider--gradient tablet-show" />
      </header>
    );
  }
}
Header.propTypes = {
  t: PropTypes.func.isRequired,
  hideAuthLinks: PropTypes.bool,
};

Header.defaultProps = {
  hideAuthLinks: false,
};

export default translate()(Header);
